<script setup lang="ts">
  import PosUiChip from '@/components/pos-v2/ui/PosUiChip.vue';
  import PosUiScrollable from '@/components/pos-v2/ui/PosUiScrollable.vue';
  import { reservationStatusCounts } from '@/domain/reservations/reservation-day-grouping';
  defineProps<{
    value: string;
    counts: ReturnType<typeof reservationStatusCounts>;
  }>();
  const emit = defineEmits<{ (event: 'input', value: string): void }>();
  const filters = [
    { id: 'all', label: 'all' },
    { id: 'pending', label: 'pending' },
    { id: 'upcoming', label: 'upcoming' },
    { id: 'present', label: 'inHouse' },
    { id: 'finished', label: 'finished' },
    { id: 'cancelled', label: 'cancelled' },
  ];
</script>

<template>
  <PosUiScrollable
    class="status-filters"
    orientation="horizontal"
    hide-scrollbar="touch"
    arrows
  >
    <div class="chips-row">
      <PosUiChip
        v-for="filter in filters"
        :key="filter.id"
        :active="value === filter.id"
        :count="counts[filter.id]"
        @click="emit('input', filter.id)"
        >{{ $t(`reservations.filter.${filter.label}`) }}</PosUiChip
      >
    </div>
  </PosUiScrollable>
</template>

<style scoped lang="scss">
  .status-filters {
    @apply tw-min-w-0;
    .chips-row {
      @apply tw-flex tw-px-3 tw-py-2;
      > * + * {
        @apply tw-ml-2;
      }
    }
  }
</style>
